export const environment = {
    environment: "production",
    pollingInterval: "1.8e+06",
    clientId: "8a812543-628e-40f0-8ab3-c40d6fd92caf",
    apiScope: "api://742d4f3d-df42-40ac-b824-f1cf98354125/AccessAPI",
    appSyncRegion: "us-east-2",
    appSyncUrl: "https://4i5hr2ag2jfitnshjpw2ikfgbu.appsync-api.us-east-2.amazonaws.com/graphql",
    navblueUrl: "https://api.flybreeze.com/navblue",
    navitaireUrl: "https://api.flybreeze.com/navitaire",
};